import axios from 'axios';
import { pipe } from 'fp-ts/function';

export const api = (baseURL: string) =>
  pipe(baseURL, baseURL => ({ baseURL }), axios.create);
